import Modal from "react-responsive-modal";
import { New } from "../../types";
import { useEffect, useRef, useState } from "react";
import moment from "moment";
import { api } from "../services/api";
import Icon from "@mdi/react";
import { mdiImage } from "@mdi/js";
import { toBase64 } from "../services/common";
import { resizeImage } from "easy-image-resizer";
import { InputDate } from ".";

type EditNewProps = {
    value: null | New;
    onChange: (value: New) => void;
    onClose: () => void;
};

export const emptyNew: New = {
    _id: "",
    title: "",
    dateFrom: moment().format("YYYY-MM-DD"),
    dateTo: null,
    text: "",
    place: "",
    picture: { type: "EASY_DB_FILE", url: "/logo-black.webp" },
};

export default function EditNew({ value, onChange, onClose }: EditNewProps) {
    const [newNews, setNewNews] = useState<New>(value ?? emptyNew);
    const [message, setMessage] = useState("");

    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        setNewNews(value ?? emptyNew);
        setMessage("");
    }, [value]);

    async function handleSave() {
        if (!newNews.title) {
            setMessage("Vyplň aspoň nadpis!");
            return;
        }

        setMessage("Ukládám...");

        if (newNews._id === "") {
            const [, error] = await api.addNews(newNews);
            if (error) {
                setMessage("Přidání aktuality selhalo");
                return;
            }
            setMessage("Aktualita přidána");
        } else {
            const [, error] = await api.updateNews(newNews);
            if (error) {
                setMessage("Ukládání změn selhalo");
                return;
            }
            setMessage("Aktualita úspěšně uložena");
        }

        onChange(newNews);
    }

    return (
        <Modal
            open={value !== null}
            onClose={onClose}
            center
            styles={{ modal: { width: "550px" } }}
        >
            <h2>
                {newNews._id === "" ? "Přidat dění v regionu" : "Upravit dění v regionu"}
            </h2>
            {message && <p className="alert">{message}</p>}
            {value && (
                <>

                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", paddingBottom: "32px" }}>
                        <div className="new-image" style={{ backgroundImage: `url(${newNews.picture.url})`, height: "320px" }} />
                        <button onClick={() => inputRef.current?.click()}>
                            <Icon path={mdiImage} size={1} /> Změnit obrázek události
                        </button>
                        <input
                            className="hidden"
                            ref={inputRef}
                            type="file"
                            accept="image/jpeg,image/png,image/webp"
                            onChange={async (e) => {
                                const file = e.target.files?.[0] as File;
                                if (!file) return;

                                const url = await resizeImage(file, {
                                    maxWidth: 560,
                                    maxHeight: 760,
                                    type: "webp",
                                });

                                setNewNews({ ...newNews, picture: { type: "EASY_DB_FILE", url } });
                            }}
                        />
                    </div>

                    <input
                        type="text"
                        placeholder="Napis"
                        value={newNews.title}
                        onChange={(e) => setNewNews({ ...newNews, title: e.target.value })}
                    />
                    <input
                        type="text"
                        placeholder="Místo"
                        value={newNews.place}
                        onChange={(e) => setNewNews({ ...newNews, place: e.target.value })}
                    />

                    <label>
                        <input
                            type="checkbox"
                            checked={newNews.dateTo !== null}
                            onChange={(e) => setNewNews({ ...newNews, dateTo: e.target.checked ? moment(newNews.dateFrom).add(1, "day").format("YYYY-MM-DD") : null })}
                        />
                        Jedná se o vícedenní událost
                    </label>
                    <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                        <InputDate
                            value={newNews.dateFrom}
                            onChange={(dateFrom) => setNewNews({ ...newNews, dateFrom })}
                        />
                        {newNews.dateTo !== null && <>
                            <div style={{ marginBottom: "20px" }}> až </div>
                            <InputDate
                                value={newNews.dateTo}
                                onChange={(dateTo) => setNewNews({ ...newNews, dateTo })}
                            />
                        </>}
                    </div>

                    <textarea
                        style={{ minHeight: "250px" }}
                        placeholder="Obsah"
                        onChange={(e) =>
                            setNewNews({ ...newNews, text: e.target.value })}
                    >
                        {newNews.text}
                    </textarea>
                    <button onClick={handleSave}>
                        {newNews._id === ""
                            ? "Přidat"
                            : "Uložit změny"}
                    </button>
                </>
            )}
        </Modal>
    );
}
